// Central design tokens for the game. Dark, flat, high-contrast, zero decoration.
// Fonts are loaded in app/_layout.tsx (Space Grotesk family, loaded via expo-font).

export const colors = {
  surface: "#050505",
  surfaceSecondary: "#101010",
  surfaceTertiary: "#1A1A1A",
  onSurface: "#FFFFFF",
  onSurfaceMuted: "#8A8A8A",
  onSurfaceDim: "#5A5A5A",
  brand: "#32D74B",
  brandDim: "#13381A",
  onBrand: "#000000",
  success: "#32D74B",
  error: "#FF453A",
  border: "#222222",
  borderStrong: "#333333",
};

export const fonts = {
  regular: "SpaceGrotesk-Regular",
  medium: "SpaceGrotesk-Medium",
  semibold: "SpaceGrotesk-SemiBold",
  bold: "SpaceGrotesk-Bold",
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
  xxxl: 48,
};

export const radius = {
  sm: 4,
  md: 8,
  lg: 16,
  pill: 999,
};

export const TURN_DURATION_MS = 6000;
